export enum PrivilegeType {
  ADMIN = 'ADMIN',
  USER_STANDARD = 'USER_STANDARD',
  USER_MAINTENANCE = 'USER_MAINTENANCE'
}
